// extracted by mini-css-extract-plugin
module.exports = {"container":"JobSummary_container__1x487","spinner":"JobSummary_spinner___niaZ"};